// extracted by mini-css-extract-plugin
export var commentTooltip = "comment-tooltip__s97w";
export var firm = "firm__NNTq";
export var firmConfirmationContainer = "firm-confirmation-container__tcv6";
export var firmName = "firm-name__RVeE";
export var firstRow = "first-row__KaJh";
export var info = "info__bpH6";
export var profileCity = "profile-city__n2OE";
export var secondRow = "second-row__OBGL";